<template>
	<div :id="progressId" :class="['progress', size ? `progress-${size}` : '']">
		<div class="progress-bar completed-progress-bar"
				 role="progressbar"
				 :id="`completed_${id}`"
				 :aria-valuenow="percent.COMPLETED"
				 aria-valuemin="0"
				 aria-valuemax="100"
				 :style="{width: `${percent.COMPLETED}%`}"
				 v-tooltip.top-center="{content: $t('MAIN_CONTENT.ProgressBar.completed', { percent: percent.COMPLETED } ), trigger: 'hover click'}">
		</div>
		<div class="progress-bar in-progress-background"
				 role="progressbar"
				 :id="`inProgress_${id}`"
				 :aria-valuenow="percent.IN_PROGRESS"
				 aria-valuemin="0"
				 aria-valuemax="100"
				 :style="{width: `${percent.IN_PROGRESS}%`}"
				 v-tooltip.top-center="{content: $t('MAIN_CONTENT.ProgressBar.inProgress', { percent: percent.IN_PROGRESS } ), trigger: 'hover click'}">
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			percent: {
				type: Object,
				default: function() {
					return {
						IN_PROGRESS: 0,
						COMPLETED: 0,
						TOTAL_REQUIRED: 0
					}
				}
			},
			size: {
				type: String
			},
			id: {
				type: String
			}
		},
		computed: {
			progressId() {
				return this.id ? `progess-${this.id}` : 'progress';
			},
		},
		methods: {
			progressClass(idx) {
				let total = 0;

				for(let i = 0; i <= idx; i++) {
					total = total + this.percents[i];
				}

				if(total <= 50) {
					return "progress-bar-danger"
				} else if(total > 50 && total <= 75) {
					return "progress-bar-warning";
				} else {
					return "progress-bar-success";
				}
			},
		}
	}
</script>
